import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../asset/img/contact-img.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Contact = () => {
  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <img className={isVisible ? "animate__animated animate__zoomIn" : ""} src={contactImg} alt="Contact Us"/>
              }
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>Get In Touch</h2>
                  <p>
                    I'd love to hear from you! Whether you have feedback, questions, or just want to connect, feel free to drop me a message.
                    Please fill out your name, email, and message below, and I'll get back to you shortly.
                  </p>
                  {/* Embed Google Form */}
                  <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSc6t1V6xVrqDLhBZ2zLV95cE6M6jrqb_EOVONR9AC6srSp8bA/viewform?embedded=true" 
                  width="640" 
                  height="893" 
                  frameborder="0" 
                  marginheight="0" 
                  marginwidth="0"
                  className="contact-iframe"
                  title="Contact Form - Google Form"
                  >Loading…
                  </iframe>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
